/* eslint-disable */

/** unique or primary key constraints on table "argo.cron_task" */
export enum ArgoCronTaskConstraint {
  /** unique or primary key constraint on columns "cron_name" */
  CronTaskPkey = 'cron_task_pkey'
}

/** select columns of table "argo.cron_task" */
export enum ArgoCronTaskSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CronName = 'cron_name',
  /** column name */
  DbFunction = 'db_function',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Setting = 'setting'
}

/** update columns of table "argo.cron_task" */
export enum ArgoCronTaskUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CronName = 'cron_name',
  /** column name */
  DbFunction = 'db_function',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Setting = 'setting'
}

